function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "aqua-delivery-logo_svg__a",
  x1: 0.081,
  x2: 0.866,
  y1: 0.605,
  y2: 0.41,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#21b1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0258cf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "aqua-delivery-logo_svg__b",
  x1: 0.073,
  x2: 0.873,
  y1: 0.584,
  y2: 0.431,
  xlinkHref: "#aqua-delivery-logo_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h71.387v71.387H0z",
  "data-name": "Rectangle 115",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5554.126 8376.509a24.027 24.027 0 0124.026 24.025c0 14.23-14.615 24.035-23.966 32.873-9.332-8.832-24.087-18.7-24.087-32.873a24.027 24.027 0 0124.027-24.025z",
  "data-name": "Path 317",
  transform: "translate(-5518.095 -8368.5)",
  fill: "url(#aqua-delivery-logo_svg__a)",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 126",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.444 31.951a19.587 19.587 0 1019.587-19.587 19.587 19.587 0 00-19.587 19.587z",
  "data-name": "Path 319",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6597.289 9170.639c-3.923 5.217-9.849 12.575-9.849 16.747a9.86 9.86 0 009.83 9.861h.031a9.86 9.86 0 009.861-9.861c0-4.186-5.902-11.478-9.873-16.747z",
  "data-name": "Path 320",
  transform: "translate(-6561.27 -9151.991)",
  fill: "url(#aqua-delivery-logo_svg__b)"
}));

function SvgAquaDeliveryLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 71.387 71.387"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgAquaDeliveryLogo;